module.exports = __webpack_public_path__ + "img/passaporte-regras.4788e6b6.png";